import { FunctionComponent } from "react";
import { Outlet } from "react-router";
import { observer } from "mobx-react-lite";

import "./Content.scss";

const RawContentComponent: FunctionComponent = () => {
  return <Outlet />;
};

export const ContentComponent = observer(RawContentComponent);
